import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TermsConditionsContainerComponent } from './containers/terms-conditions-container.component';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  declarations: [TermsConditionsContainerComponent],
  entryComponents: [TermsConditionsContainerComponent],
})
export class TermsConditionsDialogModule {}
